import { useEffect, useState } from 'react';

import { ia } from 'lib/helpers/utility';

import mascot from 'assets/Images/myriad-motion/mascot.png';

import Icon from 'components/shared/Icon/Icon';

const SmartSuggestions = ({ smart_suggestions }) => {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const len = ia(smart_suggestions) ? smart_suggestions.length : 0;
    if (len <= 1) return;
    const id = setInterval(() => {
      setActive((prev) => (prev + 1) % len);
    }, 30000);
    return () => clearInterval(id);
  }, [smart_suggestions?.length]);

  useEffect(() => {
    const len = ia(smart_suggestions) ? smart_suggestions.length : 0;
    setActive((prev) => (prev >= len ? 0 : prev));
  }, [smart_suggestions?.length]);

  return (
    <div className="sidebar-messages flex h-[252px] flex-col justify-between gap-1 rounded-xl bg-white px-4 py-2">
      <div className="flex flex-col gap-1">
        <div className="flex items-center justify-between">
          <img src={mascot} alt="Myriad mascot" className="h-8 w-8 object-contain" />
          <p className="text-xs">MYRIAD SMART SUGGESTIONS</p>
          <div className="flex gap-2">
            <div className="rounded-md border border-solid border-neutral-200">
              <Icon
                className="cursor-pointer"
                icon="chevron-left-linear"
                onClick={() => {
                  const len = Array.isArray(smart_suggestions) ? smart_suggestions.length : 0;
                  if (len === 0) return;
                  setActive((prev) => (prev === 0 ? len - 1 : prev - 1));
                }}
              />
            </div>
            <div className="rounded-md border border-solid border-neutral-200">
              <Icon
                className="cursor-pointer"
                icon="chevron-right-linear"
                onClick={() => {
                  const len = Array.isArray(smart_suggestions) ? smart_suggestions.length : 0;
                  if (len === 0) return;
                  setActive((prev) => (prev + 1) % len);
                }}
              />
            </div>
          </div>
        </div>
        <div className="mb-1 text-sm">{smart_suggestions?.[active]}</div>
      </div>
      <div className="flex w-full items-center justify-center">
        <Icon icon={`carousel-dot-${(active % 5) + 1}`} />
      </div>
    </div>
  );
};

export default SmartSuggestions;
